const MIX_TYPES = new Set(["mix-flower", "mix-preroll"]);

export function isMixType(productType) {
    return MIX_TYPES.has((productType || "").toLowerCase());
}

export function mixDisplayName(name, productType, createdAt) {
    if (!isMixType(productType) || !createdAt) return name || "";
    const d = new Date(createdAt);
    if (isNaN(d)) return name || "";
    const label = `${d.getMonth() + 1}/${d.getDate()}/${String(d.getFullYear()).slice(-2)}`;
    return `${name || ""} (${label})`;
}
